import { View, Pressable, StyleSheet } from "react-native";
import { router, useSegments } from "expo-router";
import { ThemedText } from "@/components/ThemedText";
import { useTheme } from "@/hooks/useTheme";
import { MaterialCommunityIcons } from "@expo/vector-icons";

const REPORT_TYPES = [
  {
    key: "injury",
    title: "Injury Report",
    description: "Report a workplace injury or incident",
    icon: "bandage" as const,
    path: "/(injury)",
  },
  {
    key: "pay-discrepancy",
    title: "Pay Discrepancy",
    description: "Report an issue with your paycheck",
    icon: "cash-remove" as const,
    path: "/(pay-discrepancy)",
  },
];

export default function ReportsIndexScreen() {
  const { colors } = useTheme();
  const segments = useSegments();
  const basePath = (segments as string[]).includes("crew") ? "/crew/reports" : "/reports";

  return (
    <View style={[styles.container, { backgroundColor: colors.background }]}>
      <ThemedText type="title" style={styles.heading}>
        Reports
      </ThemedText>
      <View style={styles.list}>
        {REPORT_TYPES.map((report) => (
          <Pressable
            key={report.key}
            onPress={() => router.push(`${basePath}${report.path}` as any)}
            style={({ pressed }) => [
              styles.card,
              {
                backgroundColor: colors.card,
                borderColor: colors.border,
                opacity: pressed ? 0.7 : 1,
              },
            ]}
          >
            <View style={[styles.iconContainer, { backgroundColor: colors.primary + "15" }]}>
              <MaterialCommunityIcons name={report.icon} size={28} color={colors.primary} />
            </View>
            <View style={styles.cardContent}>
              <ThemedText type="defaultSemiBold" style={{ fontSize: 17 }}>
                {report.title}
              </ThemedText>
              <ThemedText style={{ color: colors.textSecondary, fontSize: 14, marginTop: 2 }}>
                {report.description}
              </ThemedText>
            </View>
            <MaterialCommunityIcons name="chevron-right" size={24} color={colors.textSecondary} />
          </Pressable>
        ))}
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    padding: 16,
  },
  heading: {
    marginBottom: 16,
  },
  list: {
    gap: 12,
  },
  card: {
    flexDirection: "row",
    alignItems: "center",
    padding: 16,
    borderRadius: 12,
    borderWidth: StyleSheet.hairlineWidth,
    gap: 14,
  },
  iconContainer: {
    width: 48,
    height: 48,
    borderRadius: 12,
    alignItems: "center",
    justifyContent: "center",
  },
  cardContent: {
    flex: 1,
  },
});
